"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _editor = require("composer-lib/redux/actions/editor");

var _actions = require("composer-lib/redux/actions");

var _BodyEditor = _interopRequireDefault(require("composer-lib/components/composer/BodyEditor"));

var _CommentsContainer = _interopRequireDefault(require("composer-lib/containers/comments/CommentsContainer"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _constants = require("composer-lib/lib/constants");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _conversations = require("composer-lib/redux/actions/conversations");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Pages = _interopRequireDefault(require("composer-lib/data/model/Pages"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _composer = require("composer-lib/redux/actions/composer");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _uiSettings = require("composer-lib/redux/actions/uiSettings");

var _lock = require("composer-lib/redux/actions/lock");

var _userAttributes = require("composer-lib/redux/actions/userAttributes");

var _UserAttributes = _interopRequireDefault(require("composer-lib/data/model/UserAttributes"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    app: state.app,
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    googleDocs: state.googleDocs,
    lock: state.lock,
    pages: state.pages,
    saveState: state.save,
    userAttributes: state.userAttributes
  };
};

var mapDispatchToProps = {
  addToast: _actions.addToast,
  clipLinkLoaded: _editor.clipLinkLoaded,
  hideAddConversationButton: _conversations.hideAddConversationButton,
  insertImage: _editor.insertImage,
  insertVideo: _editor.insertVideo,
  insertEmbed: _editor.insertEmbed,
  insertQuestionAndAnswer: _editor.insertQuestionAndAnswer,
  insertableLoaded: _editor.insertableLoaded,
  restoreSelection: _editor.restoreSelection,
  saveComposition: _composer.saveComposition,
  saveCompositionPending: _composer.saveCompositionPending,
  setBodyEditorActive: _actions.setBodyEditorActive,
  setEditorLoaded: _actions.setEditorLoaded,
  showAddConversationButton: _conversations.showAddConversationButton,
  showGoogleAuthModal: _uiSettings.showGoogleAuthModal,
  showGoogleDocsPicker: _uiSettings.showGoogleDocsPicker,
  showLockedModal: _lock.showLockedModal,
  updateContentToSave: _composer.updateContentToSave,
  updateUserAttribute: _userAttributes.updateUserAttribute
};
var BodyEditorContainer = (0, _createReactClass.default)({
  displayName: "BodyEditorContainer",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func.isRequired,
    addToast: _propTypes.default.func.isRequired,
    app: _propTypes.default.instanceOf(_AppState.default).isRequired,
    auth: _propTypes.default.object,
    autoFocus: _propTypes.default.bool,
    clipLinkLoaded: _propTypes.default.func.isRequired,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    containerClassNames: _propTypes.default.string,
    editorClassNames: _propTypes.default.string,
    googleDocs: _propTypes.default.instanceOf(_GoogleDocs.default).isRequired,
    handleKeyCommand: _propTypes.default.func.isRequired,
    hideAddConversationButton: _propTypes.default.func.isRequired,
    insertableLoaded: _propTypes.default.func.isRequired,
    insertEmbed: _propTypes.default.func.isRequired,
    insertImage: _propTypes.default.func.isRequired,
    insertQuestionAndAnswer: _propTypes.default.func.isRequired,
    insertVideo: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    pages: _propTypes.default.instanceOf(_Pages.default).isRequired,
    properties: _propTypes.default.instanceOf(_immutable.Map),
    questionsMap: _propTypes.default.instanceOf(_immutable.Map),
    removeKeyCommandListener: _propTypes.default.func.isRequired,
    required: _propTypes.default.bool.isRequired,
    restoreSelection: _propTypes.default.func.isRequired,
    saveComposition: _propTypes.default.func.isRequired,
    saveCompositionPending: _propTypes.default.func.isRequired,
    saveQuestion: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    setBodyEditorActive: _propTypes.default.func.isRequired,
    setEditorLoaded: _propTypes.default.func,
    showAddConversationButton: _propTypes.default.func.isRequired,
    showGoogleAuthModal: _propTypes.default.func.isRequired,
    showGoogleDocsPicker: _propTypes.default.func.isRequired,
    showLabel: _propTypes.default.bool,
    showLockedModal: _propTypes.default.func.isRequired,
    tabIndex: _propTypes.default.string,
    updateContentToSave: _propTypes.default.func.isRequired,
    updateUserAttribute: _propTypes.default.func.isRequired,
    userAttributes: _propTypes.default.instanceOf(_UserAttributes.default).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      required: false,
      showLabel: false,
      autoFocus: false,
      properties: (0, _immutable.Map)(),
      questionsMap: (0, _immutable.Map)()
    };
  },
  renderConversations: function renderConversations() {
    var composerSettings = this.props.composerSettings;

    if (!composerSettings.features[_constants.ComposerFeatures.CONVERSATIONS]) {
      return null;
    }

    return _react.default.createElement(_CommentsContainer.default, null);
  },
  render: function render() {
    var _this$props = this.props,
        addKeyCommandListener = _this$props.addKeyCommandListener,
        app = _this$props.app,
        auth = _this$props.auth,
        autoFocus = _this$props.autoFocus,
        composerSettings = _this$props.composerSettings,
        composition = _this$props.composition,
        containerClassNames = _this$props.containerClassNames,
        editorClassNames = _this$props.editorClassNames,
        googleDocs = _this$props.googleDocs,
        handleKeyCommand = _this$props.handleKeyCommand,
        lock = _this$props.lock,
        pages = _this$props.pages,
        properties = _this$props.properties,
        removeKeyCommandListener = _this$props.removeKeyCommandListener,
        required = _this$props.required,
        saveState = _this$props.saveState,
        showLabel = _this$props.showLabel,
        tabIndex = _this$props.tabIndex,
        userAttributes = _this$props.userAttributes,
        questionsMap = _this$props.questionsMap,
        saveQuestion = _this$props.saveQuestion;

    if (!saveState.content) {
      return null;
    }

    var containerClasses = (0, _classnames.default)(_constants.BODY_EDITOR_CLASSNAME, containerClassNames);
    return _react.default.createElement("div", {
      className: containerClasses
    }, _react.default.createElement(_BodyEditor.default, {
      app: app,
      addToast: this.props.addToast,
      addKeyCommandListener: addKeyCommandListener,
      auth: auth,
      autoFocus: autoFocus,
      clipLinkLoaded: this.props.clipLinkLoaded,
      composerSettings: composerSettings,
      composition: composition,
      properties: properties,
      questionsMap: questionsMap,
      editorClassNames: editorClassNames,
      googleDocs: googleDocs,
      handleKeyCommand: handleKeyCommand,
      saveQuestion: saveQuestion,
      hideAddConversationButton: this.props.hideAddConversationButton,
      insertImage: this.props.insertImage,
      insertVideo: this.props.insertVideo,
      insertQuestionAndAnswer: this.props.insertQuestionAndAnswer,
      insertEmbed: this.props.insertEmbed,
      insertableLoaded: this.props.insertableLoaded,
      lock: lock,
      pages: pages,
      removeKeyCommandListener: removeKeyCommandListener,
      required: required,
      restoreSelection: this.props.restoreSelection,
      saveComposition: this.props.saveComposition,
      saveCompositionPending: this.props.saveCompositionPending,
      saveState: saveState,
      setBodyEditorActive: this.props.setBodyEditorActive,
      setEditorLoaded: this.props.setEditorLoaded,
      showAddConversationButton: this.props.showAddConversationButton,
      showGoogleAuthModal: this.props.showGoogleAuthModal,
      showGoogleDocsPicker: this.props.showGoogleDocsPicker,
      showLabel: showLabel,
      showLockedModal: this.props.showLockedModal,
      tabIndex: tabIndex,
      updateContentToSave: this.props.updateContentToSave,
      updateUserAttribute: this.props.updateUserAttribute,
      userAttributes: userAttributes
    }), this.renderConversations());
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BodyEditorContainer);

exports.default = _default;
module.exports = exports.default;